import {
    Component,
    Output,
    Input,
    EventEmitter,
    OnChanges,
    AfterViewInit,
    SimpleChange,
    ChangeDetectionStrategy,
    NgZone,
    ElementRef,
    ViewChild,
    Renderer
} from '@angular/core';
import { NetworkTreeHolder } from '../network-tree-holder/network-tree-holder.component';
import { TreeService, TreeNode } from '../../../../../common/tree';

@Component({
    selector: 'network-tree-vcd',
    template: `
       <div>
        <network-tree-holder #treeview
        [state]="state"
        [actionsMap]="menuActionMapping"
        [networkTreeVisible]="networkTreeVisible"
        [linksMap]="menuLinksMapping" autofocus>
        </network-tree-holder>
      </div>
    `
})
export class NetworkTreeVCD implements AfterViewInit {
    @Input() state: any;
    @Input() forceReloadTree: any;
    @Input() networkTreeVisible: boolean;
    show: boolean = true;
    @Output() onShow = new EventEmitter();
    @ViewChild('treeview') treeView: NetworkTreeHolder;
    menuActionMapping: any;
    menuLinksMapping: any;
    constructor(private element: ElementRef,
                private renderer: Renderer, private ngZone: NgZone) {
        this.show = true;
        this.menuActionMapping = {
        };
        this.menuLinksMapping = {
        };
    }

    ngOnInit() {
        this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    }

    ngAfterViewInit() {
        // TODO Find the first root node and preselect
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        // TODO - Capture state changes and set child components
    }

    toggleState() {
        this.show = !this.show;
        if (this.show) {
            this.onShow.emit(this.show);
            this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/network-tree/network-tree-vcd/network-tree-vcd.component.ts